import React from 'react';
import './NotFound.css';

function NotFound() {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="logo-container">
          <img
            src="/salus-logo.svg"
            alt="SalusEMR Logo"
            className="salus-logo"
          />
        </div>
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-description">
          The requested image editor page could not be found.
          Please ensure you have the correct URL format.
        </p>
        <div className="required-params">
          <h3>Valid URL Format:</h3>
          <p>Only the following URL is currently supported:</p>
        </div>
        <div className="example-url">
          <h3>Valid URL:</h3>
          <code>
            http://localhost:3000/image?img_url=null&type=1&id=46&face_pos=front
          </code>
        </div>
        <div className="actions">
          <button
            className="close-btn"
            onClick={() => window.close()}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
